export default __webpack_public_path__ + "assets/webgl/picking-3.e69dce08.glb";